module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-12-01",
		"endpointPrefix": "elasticbeanstalk",
		"protocol": "query",
		"serviceAbbreviation": "Elastic Beanstalk",
		"serviceFullName": "AWS Elastic Beanstalk",
		"signatureVersion": "v4",
		"uid": "elasticbeanstalk-2010-12-01",
		"xmlNamespace": "http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"
	},
	"operations": {
		"AbortEnvironmentUpdate": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"ApplyEnvironmentManagedAction": {
			"input": {
				"type": "structure",
				"required": [
					"ActionId"
				],
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"ActionId": {}
				}
			},
			"output": {
				"resultWrapper": "ApplyEnvironmentManagedActionResult",
				"type": "structure",
				"members": {
					"ActionId": {},
					"ActionDescription": {},
					"ActionType": {},
					"Status": {}
				}
			}
		},
		"CheckDNSAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"CNAMEPrefix"
				],
				"members": {
					"CNAMEPrefix": {}
				}
			},
			"output": {
				"resultWrapper": "CheckDNSAvailabilityResult",
				"type": "structure",
				"members": {
					"Available": {
						"type": "boolean"
					},
					"FullyQualifiedCNAME": {}
				}
			}
		},
		"ComposeEnvironments": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"GroupName": {},
					"VersionLabels": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"shape": "Si",
				"resultWrapper": "ComposeEnvironmentsResult"
			}
		},
		"CreateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"Description": {},
					"ResourceLifecycleConfig": {
						"shape": "S14"
					}
				}
			},
			"output": {
				"shape": "S1a",
				"resultWrapper": "CreateApplicationResult"
			}
		},
		"CreateApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"Description": {},
					"SourceBuildInformation": {
						"shape": "S1f"
					},
					"SourceBundle": {
						"shape": "S1j"
					},
					"BuildConfiguration": {
						"type": "structure",
						"required": [
							"CodeBuildServiceRole",
							"Image"
						],
						"members": {
							"ArtifactName": {},
							"CodeBuildServiceRole": {},
							"ComputeType": {},
							"Image": {},
							"TimeoutInMinutes": {
								"type": "integer"
							}
						}
					},
					"AutoCreateApplication": {
						"type": "boolean"
					},
					"Process": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1r",
				"resultWrapper": "CreateApplicationVersionResult"
			}
		},
		"CreateConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"SourceConfiguration": {
						"type": "structure",
						"members": {
							"ApplicationName": {},
							"TemplateName": {}
						}
					},
					"EnvironmentId": {},
					"Description": {},
					"OptionSettings": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"shape": "S22",
				"resultWrapper": "CreateConfigurationTemplateResult"
			}
		},
		"CreateEnvironment": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"EnvironmentName": {},
					"GroupName": {},
					"Description": {},
					"CNAMEPrefix": {},
					"Tier": {
						"shape": "S10"
					},
					"Tags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"VersionLabel": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"OptionSettings": {
						"shape": "S1w"
					},
					"OptionsToRemove": {
						"shape": "S29"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "CreateEnvironmentResult"
			}
		},
		"CreateStorageLocation": {
			"output": {
				"resultWrapper": "CreateStorageLocationResult",
				"type": "structure",
				"members": {
					"S3Bucket": {}
				}
			}
		},
		"DeleteApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"TerminateEnvByForce": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"DeleteSourceBundle": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {}
				}
			}
		},
		"DeleteEnvironmentConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"EnvironmentName"
				],
				"members": {
					"ApplicationName": {},
					"EnvironmentName": {}
				}
			}
		},
		"DescribeApplicationVersions": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabels": {
						"shape": "S1c"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeApplicationVersionsResult",
				"type": "structure",
				"members": {
					"ApplicationVersions": {
						"type": "list",
						"member": {
							"shape": "S1s"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeApplications": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeApplicationsResult",
				"type": "structure",
				"members": {
					"Applications": {
						"type": "list",
						"member": {
							"shape": "S1b"
						}
					}
				}
			}
		},
		"DescribeConfigurationOptions": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {},
					"SolutionStackName": {},
					"Options": {
						"shape": "S29"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeConfigurationOptionsResult",
				"type": "structure",
				"members": {
					"SolutionStackName": {},
					"Options": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Namespace": {},
								"Name": {},
								"DefaultValue": {},
								"ChangeSeverity": {},
								"UserDefined": {
									"type": "boolean"
								},
								"ValueType": {},
								"ValueOptions": {
									"type": "list",
									"member": {}
								},
								"MinValue": {
									"type": "integer"
								},
								"MaxValue": {
									"type": "integer"
								},
								"MaxLength": {
									"type": "integer"
								},
								"Regex": {
									"type": "structure",
									"members": {
										"Pattern": {},
										"Label": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeConfigurationSettings": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeConfigurationSettingsResult",
				"type": "structure",
				"members": {
					"ConfigurationSettings": {
						"type": "list",
						"member": {
							"shape": "S22"
						}
					}
				}
			}
		},
		"DescribeEnvironmentHealth": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"AttributeNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentHealthResult",
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"HealthStatus": {},
					"Status": {},
					"Color": {},
					"Causes": {
						"shape": "S3e"
					},
					"ApplicationMetrics": {
						"shape": "S3g"
					},
					"InstancesHealth": {
						"type": "structure",
						"members": {
							"NoData": {
								"type": "integer"
							},
							"Unknown": {
								"type": "integer"
							},
							"Pending": {
								"type": "integer"
							},
							"Ok": {
								"type": "integer"
							},
							"Info": {
								"type": "integer"
							},
							"Warning": {
								"type": "integer"
							},
							"Degraded": {
								"type": "integer"
							},
							"Severe": {
								"type": "integer"
							}
						}
					},
					"RefreshedAt": {
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeEnvironmentManagedActionHistory": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentManagedActionHistoryResult",
				"type": "structure",
				"members": {
					"ManagedActionHistoryItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"ActionType": {},
								"ActionDescription": {},
								"FailureType": {},
								"Status": {},
								"FailureDescription": {},
								"ExecutedTime": {
									"type": "timestamp"
								},
								"FinishedTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeEnvironmentManagedActions": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"Status": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentManagedActionsResult",
				"type": "structure",
				"members": {
					"ManagedActions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"ActionDescription": {},
								"ActionType": {},
								"Status": {},
								"WindowStartTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeEnvironmentResources": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentResourcesResult",
				"type": "structure",
				"members": {
					"EnvironmentResources": {
						"type": "structure",
						"members": {
							"EnvironmentName": {},
							"AutoScalingGroups": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Instances": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Id": {}
									}
								}
							},
							"LaunchConfigurations": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"LoadBalancers": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Triggers": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Queues": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"URL": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeEnvironments": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"EnvironmentIds": {
						"type": "list",
						"member": {}
					},
					"EnvironmentNames": {
						"type": "list",
						"member": {}
					},
					"IncludeDeleted": {
						"type": "boolean"
					},
					"IncludedDeletedBackTo": {
						"type": "timestamp"
					}
				}
			},
			"output": {
				"shape": "Si",
				"resultWrapper": "DescribeEnvironmentsResult"
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"TemplateName": {},
					"EnvironmentId": {},
					"EnvironmentName": {},
					"RequestId": {},
					"Severity": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventDate": {
									"type": "timestamp"
								},
								"Message": {},
								"ApplicationName": {},
								"VersionLabel": {},
								"TemplateName": {},
								"EnvironmentName": {},
								"RequestId": {},
								"Severity": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstancesHealth": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"AttributeNames": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeInstancesHealthResult",
				"type": "structure",
				"members": {
					"InstanceHealthList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InstanceId": {},
								"HealthStatus": {},
								"Color": {},
								"Causes": {
									"shape": "S3e"
								},
								"LaunchedAt": {
									"type": "timestamp"
								},
								"ApplicationMetrics": {
									"shape": "S3g"
								},
								"System": {
									"type": "structure",
									"members": {
										"CPUUtilization": {
											"type": "structure",
											"members": {
												"User": {
													"type": "double"
												},
												"Nice": {
													"type": "double"
												},
												"System": {
													"type": "double"
												},
												"Idle": {
													"type": "double"
												},
												"IOWait": {
													"type": "double"
												},
												"IRQ": {
													"type": "double"
												},
												"SoftIRQ": {
													"type": "double"
												}
											}
										},
										"LoadAverage": {
											"type": "list",
											"member": {
												"type": "double"
											}
										}
									}
								},
								"Deployment": {
									"type": "structure",
									"members": {
										"VersionLabel": {},
										"DeploymentId": {
											"type": "long"
										},
										"Status": {},
										"DeploymentTime": {
											"type": "timestamp"
										}
									}
								},
								"AvailabilityZone": {},
								"InstanceType": {}
							}
						}
					},
					"RefreshedAt": {
						"type": "timestamp"
					},
					"NextToken": {}
				}
			}
		},
		"ListAvailableSolutionStacks": {
			"output": {
				"resultWrapper": "ListAvailableSolutionStacksResult",
				"type": "structure",
				"members": {
					"SolutionStacks": {
						"type": "list",
						"member": {}
					},
					"SolutionStackDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SolutionStackName": {},
								"PermittedFileTypes": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			}
		},
		"RebuildEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"RequestEnvironmentInfo": {
			"input": {
				"type": "structure",
				"required": [
					"InfoType"
				],
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"InfoType": {}
				}
			}
		},
		"RestartAppServer": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"RetrieveEnvironmentInfo": {
			"input": {
				"type": "structure",
				"required": [
					"InfoType"
				],
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"InfoType": {}
				}
			},
			"output": {
				"resultWrapper": "RetrieveEnvironmentInfoResult",
				"type": "structure",
				"members": {
					"EnvironmentInfo": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InfoType": {},
								"Ec2InstanceId": {},
								"SampleTimestamp": {
									"type": "timestamp"
								},
								"Message": {}
							}
						}
					}
				}
			}
		},
		"SwapEnvironmentCNAMEs": {
			"input": {
				"type": "structure",
				"members": {
					"SourceEnvironmentId": {},
					"SourceEnvironmentName": {},
					"DestinationEnvironmentId": {},
					"DestinationEnvironmentName": {}
				}
			}
		},
		"TerminateEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"TerminateResources": {
						"type": "boolean"
					},
					"ForceTerminate": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "TerminateEnvironmentResult"
			}
		},
		"UpdateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "S1a",
				"resultWrapper": "UpdateApplicationResult"
			}
		},
		"UpdateApplicationResourceLifecycle": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"ResourceLifecycleConfig"
				],
				"members": {
					"ApplicationName": {},
					"ResourceLifecycleConfig": {
						"shape": "S14"
					}
				}
			},
			"output": {
				"resultWrapper": "UpdateApplicationResourceLifecycleResult",
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"ResourceLifecycleConfig": {
						"shape": "S14"
					}
				}
			}
		},
		"UpdateApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "S1r",
				"resultWrapper": "UpdateApplicationVersionResult"
			}
		},
		"UpdateConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"Description": {},
					"OptionSettings": {
						"shape": "S1w"
					},
					"OptionsToRemove": {
						"shape": "S29"
					}
				}
			},
			"output": {
				"shape": "S22",
				"resultWrapper": "UpdateConfigurationTemplateResult"
			}
		},
		"UpdateEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"EnvironmentId": {},
					"EnvironmentName": {},
					"GroupName": {},
					"Description": {},
					"Tier": {
						"shape": "S10"
					},
					"VersionLabel": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"OptionSettings": {
						"shape": "S1w"
					},
					"OptionsToRemove": {
						"shape": "S29"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "UpdateEnvironmentResult"
			}
		},
		"ValidateConfigurationSettings": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"OptionSettings"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {},
					"OptionSettings": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"resultWrapper": "ValidateConfigurationSettingsResult",
				"type": "structure",
				"members": {
					"Messages": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Message": {},
								"Severity": {},
								"Namespace": {},
								"OptionName": {}
							}
						}
					}
				}
			}
		}
	},
	"shapes": {
		"Si": {
			"type": "structure",
			"members": {
				"Environments": {
					"type": "list",
					"member": {
						"shape": "Sk"
					}
				}
			}
		},
		"Sk": {
			"type": "structure",
			"members": {
				"EnvironmentName": {},
				"EnvironmentId": {},
				"ApplicationName": {},
				"VersionLabel": {},
				"SolutionStackName": {},
				"TemplateName": {},
				"Description": {},
				"EndpointURL": {},
				"CNAME": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Status": {},
				"AbortableOperationInProgress": {
					"type": "boolean"
				},
				"Health": {},
				"HealthStatus": {},
				"Resources": {
					"type": "structure",
					"members": {
						"LoadBalancer": {
							"type": "structure",
							"members": {
								"LoadBalancerName": {},
								"Domain": {},
								"Listeners": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Protocol": {},
											"Port": {
												"type": "integer"
											}
										}
									}
								}
							}
						}
					}
				},
				"Tier": {
					"shape": "S10"
				},
				"EnvironmentLinks": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"LinkName": {},
							"EnvironmentName": {}
						}
					}
				}
			}
		},
		"S10": {
			"type": "structure",
			"members": {
				"Name": {},
				"Type": {},
				"Version": {}
			}
		},
		"S14": {
			"type": "structure",
			"members": {
				"ServiceRole": {},
				"VersionLifecycleConfig": {
					"type": "structure",
					"members": {
						"MaxCountRule": {
							"type": "structure",
							"required": [
								"Enabled"
							],
							"members": {
								"Enabled": {
									"type": "boolean"
								},
								"MaxCount": {
									"type": "integer"
								},
								"DeleteSourceFromS3": {
									"type": "boolean"
								}
							}
						},
						"MaxAgeRule": {
							"type": "structure",
							"required": [
								"Enabled"
							],
							"members": {
								"Enabled": {
									"type": "boolean"
								},
								"MaxAgeInDays": {
									"type": "integer"
								},
								"DeleteSourceFromS3": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"Application": {
					"shape": "S1b"
				}
			}
		},
		"S1b": {
			"type": "structure",
			"members": {
				"ApplicationName": {},
				"Description": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Versions": {
					"shape": "S1c"
				},
				"ConfigurationTemplates": {
					"type": "list",
					"member": {}
				},
				"ResourceLifecycleConfig": {
					"shape": "S14"
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {}
		},
		"S1f": {
			"type": "structure",
			"required": [
				"SourceType",
				"SourceRepository",
				"SourceLocation"
			],
			"members": {
				"SourceType": {},
				"SourceRepository": {},
				"SourceLocation": {}
			}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"S3Bucket": {},
				"S3Key": {}
			}
		},
		"S1r": {
			"type": "structure",
			"members": {
				"ApplicationVersion": {
					"shape": "S1s"
				}
			}
		},
		"S1s": {
			"type": "structure",
			"members": {
				"ApplicationName": {},
				"Description": {},
				"VersionLabel": {},
				"SourceBuildInformation": {
					"shape": "S1f"
				},
				"BuildArn": {},
				"SourceBundle": {
					"shape": "S1j"
				},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Status": {}
			}
		},
		"S1w": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ResourceName": {},
					"Namespace": {},
					"OptionName": {},
					"Value": {}
				}
			}
		},
		"S22": {
			"type": "structure",
			"members": {
				"SolutionStackName": {},
				"ApplicationName": {},
				"TemplateName": {},
				"Description": {},
				"EnvironmentName": {},
				"DeploymentStatus": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"OptionSettings": {
					"shape": "S1w"
				}
			}
		},
		"S29": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ResourceName": {},
					"Namespace": {},
					"OptionName": {}
				}
			}
		},
		"S3e": {
			"type": "list",
			"member": {}
		},
		"S3g": {
			"type": "structure",
			"members": {
				"Duration": {
					"type": "integer"
				},
				"RequestCount": {
					"type": "integer"
				},
				"StatusCodes": {
					"type": "structure",
					"members": {
						"Status2xx": {
							"type": "integer"
						},
						"Status3xx": {
							"type": "integer"
						},
						"Status4xx": {
							"type": "integer"
						},
						"Status5xx": {
							"type": "integer"
						}
					}
				},
				"Latency": {
					"type": "structure",
					"members": {
						"P999": {
							"type": "double"
						},
						"P99": {
							"type": "double"
						},
						"P95": {
							"type": "double"
						},
						"P90": {
							"type": "double"
						},
						"P85": {
							"type": "double"
						},
						"P75": {
							"type": "double"
						},
						"P50": {
							"type": "double"
						},
						"P10": {
							"type": "double"
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticbeanstalk-2010-12-01.min.json
// module id = 687
// module chunks = 2